"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { twMerge } from "tailwind-merge";

import { getLinkTarget } from "@/globals";
import { BUTTON_STYLES } from "@/styles/buttons";
import { ErrorView } from "@/views/error.view";

export type NavItem = {
    href: string | undefined;
    label: string;
};

type NavItemFooterPrimaryProps = {
    navigationItem: NavItem;
};
export const NavItemFooterPrimaryView = ({ navigationItem }: NavItemFooterPrimaryProps) => {
    const currentPath = usePathname();

    if (navigationItem.href) {
        return (
            <li>
                <Link
                    href={navigationItem.href}
                    prefetch={false}
                    target={getLinkTarget(navigationItem.href)}
                    className={twMerge(
                        BUTTON_STYLES.footerNavigationPrimary(navigationItem.href === currentPath),
                    )}
                >
                    <span>{navigationItem.label}</span>
                </Link>
            </li>
        );
    } else {
        return (
            <li>
                <ErrorView>{navigationItem.label} </ErrorView>
            </li>
        );
    }
};
